module.exports = __webpack_public_path__ + "ch.svg?a69a50e544ff08eb122eedb7dc274cac";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ch.svg
// module id = 1039
// module chunks = 0